export interface Country {
  id: string
  name: string
  code: string // 2-letter code for flags or just use emoji
  color: string
}

export interface Product {
  id: string
  name: string
  subtitle: string
  price: number
  category: 'Jerseys' | 'Cleats' | 'Gear'
  countryId?: string
  image: string
  thumbnails: string[]
  badges: string[]
  description: string
}

export const countries: Country[] = [
  { id: 'ar', name: 'Argentina', code: '🇦🇷', color: '#43A1D5' },
  { id: 'br', name: 'Brazil', code: '🇧🇷', color: '#FFDF00' },
  { id: 'fr', name: 'France', code: '🇫🇷', color: '#002395' },
  { id: 'de', name: 'Germany', code: '🇩🇪', color: '#000000' },
  { id: 'es', name: 'Spain', code: '🇪🇸', color: '#AA151B' },
  { id: 'en', name: 'England', code: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', color: '#CE1124' },
  { id: 'pt', name: 'Portugal', code: '🇵🇹', color: '#046A38' },
  { id: 'jp', name: 'Japan', code: '🇯🇵', color: '#BC002D' },
  { id: 'us', name: 'USA', code: '🇺🇸', color: '#B31942' },
  { id: 'mx', name: 'Mexico', code: '🇲🇽', color: '#006847' },
  { id: 'nl', name: 'Netherlands', code: '🇳🇱', color: '#F36C21' },
  { id: 'ma', name: 'Morocco', code: '🇲🇦', color: '#C1272D' },
]

export const products: Product[] = [
  {
    id: 'p1',
    name: 'AFA Home Jersey 26',
    subtitle: 'Argentina National Team',
    price: 130,
    category: 'Jerseys',
    countryId: 'ar',
    image:
      'https://images.unsplash.com/photo-1614632537197-38a17061c2bd?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1614632537197-38a17061c2bd?q=80&w=400&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?q=80&w=400&auto=format&fit=crop',
    ],
    badges: ['New', 'Home'],
    description:
      'Woven from the fabric of champions. The official 2026 home jersey features advanced cooling technology and the iconic three stars.',
  },
  {
    id: 'p2',
    name: 'Predator Elite 26',
    subtitle: 'Firm Ground Cleats',
    price: 280,
    category: 'Cleats',
    image:
      'https://images.unsplash.com/photo-1511886929837-354d827aae26?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1511886929837-354d827aae26?q=80&w=400&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1628253747716-0c4f5c90fdda?q=80&w=400&auto=format&fit=crop',
    ],
    badges: ['Bestseller'],
    description:
      'Control the game. The new Predator Elite brings unmatched grip and precision striking to the pitch.',
  },
  {
    id: 'p3',
    name: 'FFF Away Jersey 26',
    subtitle: 'France National Team',
    price: 130,
    category: 'Jerseys',
    countryId: 'fr',
    image:
      'https://images.unsplash.com/photo-1522778119026-d647f0596c20?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1522778119026-d647f0596c20?q=80&w=400&auto=format&fit=crop',
    ],
    badges: ['Away'],
    description: 'Elegance meets performance. The France away kit for 2026.',
  },
  {
    id: 'p4',
    name: 'X Crazyfast League',
    subtitle: 'Firm Ground Cleats',
    price: 220,
    category: 'Cleats',
    image:
      'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?q=80&w=400&auto=format&fit=crop',
    ],
    badges: ['New'],
    description: 'Lightweight speed for the fastest players on the pitch.',
  },
  {
    id: 'p5',
    name: 'World Cup Pro Ball',
    subtitle: 'Official Match Ball',
    price: 165,
    category: 'Gear',
    image:
      'https://images.unsplash.com/photo-1614632537423-1e6c2e7e0aab?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1614632537423-1e6c2e7e0aab?q=80&w=400&auto=format&fit=crop',
    ],
    badges: ['Official'],
    description:
      'The official match ball of the 2026 tournament. Seamless construction for predictable trajectory.',
  },
  {
    id: 'p6',
    name: 'CBF Home Jersey 26',
    subtitle: 'Brazil National Team',
    price: 130,
    category: 'Jerseys',
    countryId: 'br',
    image:
      'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?q=80&w=400&auto=format&fit=crop',
    ],
    badges: ['Home'],
    description:
      'The iconic yellow jersey, updated for 2026 with modern performance fabrics.',
  },
  {
    id: 'p7',
    name: 'Spain Training Top',
    subtitle: 'Spain National Team',
    price: 85,
    category: 'Gear',
    countryId: 'es',
    image:
      'https://images.unsplash.com/photo-1552667466-07770ae110d0?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1552667466-07770ae110d0?q=80&w=400&auto=format&fit=crop',
    ],
    badges: [],
    description:
      'Train like the pros. Moisture-wicking top designed for intense sessions.',
  },
  {
    id: 'p8',
    name: 'Copa Pure 2',
    subtitle: 'Firm Ground Cleats',
    price: 250,
    category: 'Cleats',
    image:
      'https://images.unsplash.com/photo-1575361204480-aadea25e6e68?q=80&w=1000&auto=format&fit=crop',
    thumbnails: [
      'https://images.unsplash.com/photo-1575361204480-aadea25e6e68?q=80&w=400&auto=format&fit=crop',
    ],
    badges: ['Classic'],
    description: 'Premium leather meets modern tooling. For the purists.',
  },
]
